import React from 'react'

const Footer = () => {
  return (
    <footer className="web_footer">
      <div className="copyright_area">
        <div className="cs_container cs_row">
          <div className="copyright_text">
            <span>Copyright © <span id="year"></span> All Right Reserved
              <a className="a-white" href="https://www.smashcode.dev" target="_blank" rel="noreferrer"> Smash Code</a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer